"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistStepId = void 0;
var TrackingChecklistStepId;
(function (TrackingChecklistStepId) {
    TrackingChecklistStepId[TrackingChecklistStepId["UNKNOWN"] = 0] = "UNKNOWN";
    TrackingChecklistStepId[TrackingChecklistStepId["TRACKERS_REST_CALIBRATION"] = 1] = "TRACKERS_REST_CALIBRATION";
    TrackingChecklistStepId[TrackingChecklistStepId["FULL_RESET"] = 2] = "FULL_RESET";
    TrackingChecklistStepId[TrackingChecklistStepId["VRCHAT_SETTINGS"] = 3] = "VRCHAT_SETTINGS";
    TrackingChecklistStepId[TrackingChecklistStepId["STEAMVR_DISCONNECTED"] = 4] = "STEAMVR_DISCONNECTED";
    TrackingChecklistStepId[TrackingChecklistStepId["UNASSIGNED_HMD"] = 5] = "UNASSIGNED_HMD";
    TrackingChecklistStepId[TrackingChecklistStepId["TRACKER_ERROR"] = 6] = "TRACKER_ERROR";
    TrackingChecklistStepId[TrackingChecklistStepId["NETWORK_PROFILE_PUBLIC"] = 7] = "NETWORK_PROFILE_PUBLIC";
    TrackingChecklistStepId[TrackingChecklistStepId["MOUNTING_CALIBRATION"] = 8] = "MOUNTING_CALIBRATION";
    TrackingChecklistStepId[TrackingChecklistStepId["FEET_MOUNTING_CALIBRATION"] = 9] = "FEET_MOUNTING_CALIBRATION";
    TrackingChecklistStepId[TrackingChecklistStepId["STAY_ALIGNED_CONFIGURED"] = 10] = "STAY_ALIGNED_CONFIGURED";
    TrackingChecklistStepId[TrackingChecklistStepId["STEAMVR_HANDS_ENABLED"] = 11] = "STEAMVR_HANDS_ENABLED";
})(TrackingChecklistStepId = exports.TrackingChecklistStepId || (exports.TrackingChecklistStepId = {}));
